import React, { Component } from "react";
import InvitesStyles from "components/mgm/Invites.module.scss";

class InvitesTotal extends Component {
  render() {
    let { 
      person,
      invites
    } = this.props;
    return (
      <div className={"gb-contentblock level-2 " + InvitesStyles["invitesTotal"]}>
        <div className={InvitesStyles["invitesTotal__body"]}>
          <div className={"p-xl-5 p-2 " + InvitesStyles["invitesTotal__body__item"]}>
            Seu cupom: <strong>{person.couponName}</strong>
          </div>
          <div className={"p-xl-5 p-2 " + InvitesStyles["invitesTotal__body__item"]}>
            Utilizado: <strong>{invites.length}x</strong>
          </div>
        </div>
      </div>
    );
  }
}

class InvitesListSended extends Component {
  render() {
    const listInvited = this.props.invites.map((item, key) => {
      let date = new Date(item.DateCreated);

      return (
        <div key={key} className={InvitesStyles["invitesListBody__line"]}>
          <div>{date.toLocaleDateString()}</div>
          <div>{item.Email}</div>
          <div>{item.personRelationType}</div>
        </div>
      );
    });

    return (
      <div className={"gb-contentblock level-2"}>
        <div className={InvitesStyles["invitesListHeader"]}>
          <div>Data</div>
          <div>E-mail</div>
          <div>Situação</div>
        </div>
        <div className={InvitesStyles["invitesListBody"]}>
          {listInvited}
        </div>
      </div>
    );
  }
}

export { InvitesTotal, InvitesListSended }
//524,67